import React from "react";

const TasksIcon = () => (
  <svg
    width="1.33rem"
    height="1.33rem"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.73126 5.55H11.0125"
      stroke="#7E858F"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.98749 5.55L4.45624 6.01875L5.86249 4.6125"
      stroke="#7E858F"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.73126 9.925H11.0125"
      stroke="#7E858F"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.98749 9.925L4.45624 10.3937L5.86249 8.9875"
      stroke="#7E858F"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.625 14.5H9.375C12.5 14.5 13.75 13.25 13.75 10.125V6.375C13.75 3.25 12.5 2 9.375 2H5.625C2.5 2 1.25 3.25 1.25 6.375V10.125C1.25 13.25 2.5 14.5 5.625 14.5Z"
      stroke="#7E858F"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TasksIcon;
